import { Link } from 'react-router-dom';

const footerGroups = [
  {
    title: '逛吃瓜',
    links: [
      { label: '今日热议', href: '#trending' },
      { label: '话题分类', href: '#categories' },
      { label: '最新瓜料', href: '#articles' },
    ],
  },
  {
    title: '聊起来',
    links: [
      { label: '瓜友交流区', href: '#community' },
      { label: '常见问题', href: '#faq' },
      { label: '订阅更新', href: '#subscribe' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="w-full px-4 md:px-8 pt-14 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500 text-secondary-950 text-lg">
                <i className="ri-chat-smile-2-line" aria-hidden="true"></i>
              </span>
              <span className="font-heading font-black text-xl text-background-50">黑吃瓜网</span>
            </div>
            <p className="text-sm text-background-200/90 leading-relaxed max-w-md">
              吃瓜群众的聚集地。我们把散落的热点整理成榜单与分类，让你快速看懂来龙去脉，再和瓜友一起把它聊透。
            </p>
            <p className="mt-5 text-sm text-background-200/90 flex items-center gap-2">
              <i className="ri-mail-line text-accent-400" aria-hidden="true"></i>
              contact@heichigua.com
            </p>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title} className="md:col-span-2">
              <h3 className="font-heading font-bold text-background-50 text-sm tracking-wide mb-4">
                {group.title}
              </h3>
              <ul className="space-y-3">
                {group.links.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="text-sm text-background-200/90 hover:text-accent-400 transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-3">
            <h3 className="font-heading font-bold text-background-50 text-sm tracking-wide mb-4">
              社区约定
            </h3>
            <p className="text-sm text-background-200/90 leading-relaxed">
              理性吃瓜，不传播未经核实的信息，不进行人身攻击。看到疑问欢迎在评论区提出，我们和纠错志愿者会一起跟进。
            </p>
            <Link
              to="/"
              className="inline-flex items-center gap-1 mt-4 text-sm text-accent-400 hover:text-accent-300 transition-colors"
            >
              关于我们
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-200/70">
            © 2026 黑吃瓜网 · 保留所有权利
          </p>
          <p className="text-xs text-background-200/70">
            本站内容由瓜友共同整理，观点仅代表发布者个人。
          </p>
        </div>
      </div>
    </footer>
  );
}